import { Injectable } from '@angular/core';
import { ComponentStore } from '@ngrx/component-store';
import { SftpConfig } from './sftp-config.models';
import { delay, tap } from 'rxjs/operators';

export type SftpConnectionTestStatus = 'initial' | 'in-progress' | 'success' | 'unauthorized' | 'timeout' | 'error';
@Injectable()
export class SftpConfigComponentStore extends ComponentStore<{ connectionTestStatus: SftpConnectionTestStatus }> {
    public connectionTestStatus$ = this.select(state => state.connectionTestStatus);
    constructor() {
        super({
            connectionTestStatus: 'initial'
        });
    }

    // TODO: Implement test request (needs to be implemented SERVER-SIDE), client-side SFTP connections are generally not possible.
    public testConnection = this.effect<SftpConfig>(config$ =>
        config$.pipe(
            tap(_ => this.patchState({ connectionTestStatus: 'in-progress' })),
            delay(2000), // TODO: Delay added for testing purposes.
            tap(_ => this.patchState({ connectionTestStatus: 'unauthorized' }))
        )
    );
}
